import { Component, EventEmitter, Input, OnInit,Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentManagementNavigatorComponent } from 'src/app/Component/master/content-management-navigator/content-management-navigator.component';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';

@Component({
  selector: 'app-change-course-header',
  templateUrl: './change-course-header.component.html',
  styleUrls: ['./change-course-header.component.css'],
})
export class ChangeCourseHeaderComponent implements OnInit {
  @Input() heading= "";
  @Input() showChangeCourse= true;
  @Output() addMockExam: EventEmitter<any> = new EventEmitter();
  @Output() courseCleared: EventEmitter<any> = new EventEmitter();
  courseId: string = '';
  ExamAgencyName: string = '';
  CourseName: string = '';
  ExamYear: string = '';
  currentRoute: string = '';
  private destroy$ = new Subject<void>(); // Used for unsubscribing
  globalContentParams: any;
  constructor(
    private modalService: NgbModal,
     private route: ActivatedRoute,
     public service: ContentManagementService,
     private router: Router,
    ) {}

  ngOnInit(): void {
    this.route.url.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      // event is an array of url segments: [{path: 'Exam', ...}, {path: 'StudyUnit', ...}, ...]
      const routeSegments = event.map(seg => seg.path).join('/');
      this.currentRoute = '/' + routeSegments;
    });

    this.route.queryParams
    .pipe(takeUntil(this.destroy$))
    .subscribe((queryParams) => {
      this.service.setQueryParams({
        c_id: queryParams['c_id'],
        eA_Name: queryParams['eA_Name'],
        c_Name: queryParams['c_Name'],
        eY_Name: queryParams['eY_Name'],
        eA_Id: queryParams['eA_Id'],
        cM_id: queryParams['cM_id'],
      });
    });

  // Then combine to select best value for your fields
  combineLatest([
    this.route.queryParams.pipe(takeUntil(this.destroy$)),
    this.service.queryParams$.pipe(takeUntil(this.destroy$)),
  ]).subscribe(([queryParams, serviceParams]) => {
    this.courseId = queryParams['c_id'] || serviceParams['c_id'];
    this.ExamAgencyName = queryParams['eA_Name'] || serviceParams['eA_Name'];
    this.CourseName = queryParams['c_Name'] || serviceParams['c_Name'];
    this.ExamYear = queryParams['eY_Name'] || serviceParams['eY_Name'];
    this.globalContentParams = { ...serviceParams, ...queryParams };
  });

  }

  open() {
    const modalRef = this.modalService.open(
      ContentManagementNavigatorComponent,
      { size: 'md', backdrop: 'static', centered: true } // Adjusted to include 'centered' option
    );

    const route = this.currentRoute;
    modalRef.componentInstance.route = route;
  }
  clearSelectedCourse() {
    // Clear displayed fields
    this.courseId = '';
    this.ExamAgencyName = '';
    this.CourseName = '';
    this.ExamYear = '';
    this.globalContentParams = {};

    // Reset query params in the serviceapp-admin-dashboard
    this.service.setQueryParams({
      c_id: null,
      eA_Name: null,
      c_Name: null,
      eY_Name: null,
      eA_Id: null,
    });

    // Optional: If you want to clear query params from the URL, do this:
    this.router.navigate([], {
      queryParams: {
        c_id: null,
        eA_Name: null,
        c_Name: null,
        eY_Name: null,
        eA_Id: null,
      },
      queryParamsHandling: 'merge', // Or 'replace'
    });

    this.courseCleared.emit(true)
  }


  performAction(){
    if(this.heading === 'Admin: Course Management: MockExam : List' && !this.courseId){
      this.open()
      return
    }else if(this.heading === 'Admin: Study Unit: Practice Test : List' && !this.courseId){
      this.open()
      return
    }
    else if(this.heading === 'Admin: Course Management: Practice Test : List' && !this.courseId){
      this.open()
      return
    }
    this.addMockExam.emit(true)
  }


}
